import routeConstants from '@constants/practiceProfile.routeConstants'

export default [
  {
    value: routeConstants.PROFILE,
    path: 'profile',
    index: false,
  },
  {
    value: routeConstants.PATIENTS,
    path: 'patients',
    index: false,
  },
  {
    value: routeConstants.ORDERS,
    path: 'orders',
    index: false,
  },
  {
    value: routeConstants.SETTINGS,
    path: 'settings',
    index: false,
  },
]
